<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="branch_name"
                                       label="Branch name"
                                       v-model:field="search.branch_name" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="city"
                                       label="City"
                                       size="4"
                                       v-model:field="search.city" />

                        <FormInputText fieldName="address"
                                       label="Address"
                                       size="6"
                                       v-model:field="search.address" />

                        <FormInputText fieldName="postal_code"
                                       label="Postal code"
                                       size="2"
                                       v-model:field="search.postal_code" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="nip"
                                       label="NIP"
                                       size="3"
                                       v-model:field="search.nip" />

                        <FormInputText fieldName="phone"
                                       label="Phone"
                                       size="3"
                                       v-model:field="search.phone" />

                        <FormInputText fieldName="email"
                                       label="Email"
                                       size="4"
                                       validation="email"
                                       v-model:field="search.email" />
                        <FormSelect fieldName="is_active"
                                    label="Is active branch?"
                                    size="2"
                                    scrollHeight="100px"
                                    :allowZero="true"
                                    :showClear="true"
                                    :filtering="false"
                                    :options="yesNoOptions()"
                                    v-model:field="search.is_active" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import FormSelect from '@crud/FormSelect.vue'
import { prepareSearch, yesNoOptions } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

prepareSearch(search, props)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
